import PropTypes from 'prop-types';

export function resolveInstance(preset, state = {}) {
  return preset.reduce((instance, factory) => {
    const { name } = factory;

    if (process.env.NODE_ENV !== 'production') {
      // Валидируем необходимые условия для инстанциирования дескриптора.
      if (factory.stateTypes) {
        PropTypes.checkPropTypes(factory.stateTypes, state, 'state prop', name);
      }
    }

    const descriptor = factory(state);

    if (process.env.NODE_ENV !== 'production') {
      Object
        .keys(descriptor)
        .filter(methodName => typeof(instance[methodName]) === 'function')
        .forEach(methodName => {
          console.warn(`Please note that '${name}' is overriding instance method '${methodName}'`);
        });
    }

    return {
      ...instance,
      ...descriptor,
    };
  }, {});
}
